import { useEffect, useRef } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { es } from 'date-fns/locale/es';
import { FaRegCalendarAlt } from 'react-icons/fa';
import { FieldShell } from './FieldShell';
import { useDomFieldName, useDomFieldId } from './_useFieldName';
import { FIELD_AUTOCOMPLETE_OFF, FIELD_NO_AUTOFILL } from './_fieldDefaults';

registerLocale('es', es);

const BLOCK = 'LStudio__app_field';

/*
    🔥 FECHA — react-datepicker

    ⚠️ El CSS de la librería se importa UNA vez, en App.js. Acá solo
       van los overrides (Form.css), porque si importás su CSS desde
       este archivo se carga después del tuyo y te pisa todo.

    withPortal=false + popperClassName mantiene el calendario dentro
    del flujo pero con nuestras clases.
*/

export const FieldDate = ({
    id, name, label, hint, error,
    value, onChange,
    placeholder = 'dd/mm/aaaa', dateFormat = 'dd/MM/yyyy',
    showTime = false, minDate = null, maxDate = null,
    isRequired = false, isDisabled = false,
    onCalendarOpen = null, onCalendarClose = null,
    span = 1, ...rest
}) => {

    const DOM_NAME = useDomFieldName();

    const DOM_ID = useDomFieldId(id);
    const REF__picker = useRef(null);
    const REF__instanceId = useRef(`field_date_${Math.random().toString(36).slice(2)}`);

    const handleCalendarOpen = () => {
        if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('lstudio:field-popover-open', { detail: REF__instanceId.current }));
        }
        onCalendarOpen?.();
    };

    useEffect(() => {
        const onOtherPopoverOpen = (event) => {
            if (event?.detail !== REF__instanceId.current) REF__picker.current?.setOpen?.(false);
        };
        window.addEventListener('lstudio:field-popover-open', onOtherPopoverOpen);
        return () => window.removeEventListener('lstudio:field-popover-open', onOtherPopoverOpen);
    }, []);

    return (

    <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
        isRequired={isRequired} isDisabled={isDisabled} span={span} >

        <div className={`${BLOCK}__wrap ${BLOCK}__wrap--date`}>

            <DatePicker
                ref={REF__picker}
                id={DOM_ID} name={DOM_NAME} autoComplete="nope"
                className={`${BLOCK}__input`}
                wrapperClassName={`${BLOCK}__dp_wrap`}
                calendarClassName="LS__dp"
                popperClassName="LS__dp_popper"
                selected={value} onChange={onChange}
                placeholderText={placeholder}
                dateFormat={showTime ? `${dateFormat} HH:mm` : dateFormat}
                showTimeSelect={showTime} timeFormat="HH:mm" timeIntervals={15}
                minDate={minDate} maxDate={maxDate}
                locale="es"
                required={isRequired} disabled={isDisabled}
                autoComplete={FIELD_AUTOCOMPLETE_OFF}
                showPopperArrow={false}
                onCalendarOpen={handleCalendarOpen}
                onCalendarClose={onCalendarClose}
                {...FIELD_NO_AUTOFILL}
                {...rest}
            />

            <span className={`${BLOCK}__icon ${BLOCK}__icon--end`} aria-hidden="true">
                <FaRegCalendarAlt />
            </span>

        </div>

    </FieldShell>
);
};
